import React, { Fragment } from 'react'; //
// Global
// --------------------------------------------------

import Global from "../../styles/global-styles";
import ScaffoldingLegacy from "../../styles/scaffolding-legacy";
export var GlobalStyles = function GlobalStyles(_ref) {
  var scaffoldingLegacy = _ref.scaffoldingLegacy;

  if (scaffoldingLegacy) {
    /* eslint-disable-next-line no-console */
    console.warn('The scaffolding legacy resets will be removed in an upcoming release, and have not been migrated to use the semantic color theming system. Please refer to the "Global styles" section in the v2 release notes (https://ghe.spotify.net/encore/web/releases/tag/v2.0.0) for instructions on migrating off of these resets.');
  }

  return /*#__PURE__*/React.createElement(Fragment, null, scaffoldingLegacy && /*#__PURE__*/React.createElement(ScaffoldingLegacy, null), /*#__PURE__*/React.createElement(Global, null));
};
/**
* **GlobalStyles** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/GlobalStyles) | [Storybook](https://encore-web.spotify.net/?path=/story/components-globalstyles--default) |  
*
* null
*
* @example
* () => <GlobalStyles />;
*
*/

export default GlobalStyles;